<template>
  <div class="text-standard">

    <!-- <Block2Cols>
      <template #col1>
        <MARSTitle>{{ $t('object-capture.hero-section-title') }}</MARSTitle>
      </template>
      <template #col2>
        <p v-html="$t('object-capture.hero-section-text')"></p>
      </template>
    </Block2Cols> -->

    <Block01
      :scrollIndicator="false"
      :imageUrlBelow="imgHero"
      :alt="$t('viewer-3d-ar.block01.alt')"
    >
      <template #title>
        <div class="mt-8 xl:mt-0 text-highlight" style="text-shadow:0 0 4px white;">
          <span class="font-smaller">{{ $t('object-capture.hero-section-title-from') }}</span> {{ $t('object-capture.hero-section-title-photos') }}
          <span class="whitespace-nowrap"><span class="font-smaller">{{ $t('object-capture.hero-section-title-to') }}</span> {{ $t('object-capture.hero-section-title-3d-models') }}</span>
        </div>
      </template>
      <template #footer>
        <div class="laptop:absolute laptop:bottom-hero w-full flex justify-center">
          <p class="" v-html="$t('object-capture.hero-section-text')"></p>
        </div>
      </template>
    </Block01>

    <Block2Cols>
      <template #col1>
        <MARSTitle>{{ $t('object-capture.what-is-title') }}</MARSTitle>
      </template>
      <template #col2>
        <p v-html="$t('object-capture.what-is-text')"></p>
      </template>
    </Block2Cols>


    <Block2Cols>
      <template #col1>
        <p v-html="$t('object-capture.create-from-photos-1')"></p>
      </template>
      <template #col2>
        <p v-html="$t('object-capture.create-from-photos-2')"></p>
      </template>
    </Block2Cols>

    <Block1Col compact>
      <video class="" src="~/assets/video/landing/object-capture/create-from-photos.mp4" playsinline autoplay muted
             loop />
    </Block1Col>

    <Block2Cols>
      <template #col1>
        <MARSTitle>{{ $t('object-capture.lets-start-title') }}</MARSTitle>
      </template>
    </Block2Cols>

    <Block2Cols compact class="mt-8">
      <template #col1>
        <h2>{{ $t('object-capture.step1-step') }}</h2>
        <h3>{{ $t('object-capture.step1-title') }}</h3>
        <p>{{ $t('object-capture.step1-text') }}</p>
      </template>
      <template #col2>
        <img loading="lazy" src="~/assets/img/object-capture/many-photos-of-your-object.webp" alt="{{ $t('object-capture.step1-image-alt') }}">
      </template>
    </Block2Cols>
    <Block2Cols compact class="mt-8">
      <template #col1>
        <h2>{{ $t('object-capture.step2-step') }}</h2>
        <h3>{{ $t('object-capture.step2-title') }}</h3>
        <p v-html="$t('object-capture.step2-text')" />
      </template>
      <template #col2>
        <img loading="lazy" src="~/assets/img/object-capture/drag-and-drop-photos-into-my-ar-studio.webp" alt="{{ $t('object-capture.step3-image-alt') }}">
      </template>
    </Block2Cols>
    <Block2Cols compact class="mt-8">
      <template #col1>
        <h2>{{ $t('object-capture.step3-step') }}</h2>
        <h3>{{ $t('object-capture.step3-title') }}</h3>
        <p>{{ $t('object-capture.step3-text') }}</p>
        <ul>
        <li v-html="$t('object-capture.step3-direct_link')" />
        <li v-html="$t('object-capture.step3-embed_code')" />
        <li v-html="$t('object-capture.step3-qr_code')" />
        <li v-html="$t('object-capture.step3-download')"></li>
        </ul>
      </template>
      <template #col2>
        <img loading="lazy" src="~/assets/img/object-capture/captured-3d-model.webp" alt="{{ $t('object-capture.step3-image-alt') }}">
      </template>
    </Block2Cols>

    <Block2Cols id="promo">
      <template #col1>
        <p v-html="$t('object-capture.promo-title')"></p>
        <p class="text-xs" v-html="$t('object-capture.promo-code-description')"></p>
      </template>
      <template #col2>
        <ActionButton :href="panelLinks.registerUrl.value" :value="$t('object-capture.promo-code-label')" :bg="Colors.orange" :fg="Colors.white"
          marginTop="" marginTopTablet="" marginTopLaptop=""/>
      </template>
    </Block2Cols>

    <Block1Col class="mb-8">
      <MARSTitle>{{ $t('object-capture.some_examples') }}</MARSTitle>
      <p>{{ $t('object-capture.examples_intro') }}</p>
    </Block1Col>

    <ShowcaseSelector :models="showcaseModels"/>

    <Block2Cols>
      <template #col1>
        <p v-html="$t('object-capture.conclusion')"></p>
      </template>
      <template #col2>
        <ActionButton :href="$t('links.guide-object-capture')" :value="$t('artag.documentation-btn')" :bg="Colors.highlight" :fg="Colors.white" />
      </template>
    </Block2Cols>

  </div>
</template>

<script setup lang="ts">
import MARSTitle from '@/components/MARSTitle.vue'
import Box from '@/components/Box.vue'
import { useIubenda } from 'mars-iubenda-vite';

import imgHero from "~/assets/img/object-capture/object-capture-hero.webp"

const panelLinks = usePanelLinks();
const {youtubeEnabled} = useIubenda()

const showcaseModels = [
  {
    industry: 'object-capture.showcase.joe-nimble.industry',
    name: 'object-capture.showcase.joe-nimble.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/72b78276-44d0-5bc1-ad77-2bc96269ad63/default/374f5528-0f11-5778-8400-010b8922fb8d/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/72b78276-44d0-5bc1-ad77-2bc96269ad63/default/374f5528-0f11-5778-8400-010b8922fb8d/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.vivo-barefoot.industry',
    name: 'object-capture.showcase.vivo-barefoot.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/32dd78a0-ec1a-5558-b270-de2205e87977/default/1d7bbeb8-1929-5388-b9e4-9e0acb530771/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/32dd78a0-ec1a-5558-b270-de2205e87977/default/1d7bbeb8-1929-5388-b9e4-9e0acb530771/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.mizuno.industry',
    name: 'object-capture.showcase.mizuno.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/68b75f40-9f65-5b23-8964-7c36ec2ac844/default/86c079be-0a33-5605-9f55-37e8ed117c73/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/68b75f40-9f65-5b23-8964-7c36ec2ac844/default/86c079be-0a33-5605-9f55-37e8ed117c73/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.adidas.industry',
    name: 'object-capture.showcase.adidas.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/49527266-81f7-5481-9e43-b1b5f333075e/default/09b8cb7b-9ad0-5d21-853d-c616d77bc1a7/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/49527266-81f7-5481-9e43-b1b5f333075e/default/09b8cb7b-9ad0-5d21-853d-c616d77bc1a7/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.kalenji.industry',
    name: 'object-capture.showcase.kalenji.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/3bdafe19-b8db-5f42-be1b-c48e0336db40/default/388f7284-c407-5ea3-9563-6912852b72b3/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/3bdafe19-b8db-5f42-be1b-c48e0336db40/default/388f7284-c407-5ea3-9563-6912852b72b3/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.lumberjack.industry',
    name: 'object-capture.showcase.lumberjack.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/670f3186-f6ef-5e5c-8cca-9218258a34ca/default/db69203e-94be-5f52-9bc3-305c47403f1f/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/670f3186-f6ef-5e5c-8cca-9218258a34ca/default/db69203e-94be-5f52-9bc3-305c47403f1f/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.roman-helmet.industry',
    name: 'object-capture.showcase.roman-helmet.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/aeebcbd2-d7ac-5de6-bc69-91315b0764da/default/388f7284-c407-5ea3-9563-6912852b72b3/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/aeebcbd2-d7ac-5de6-bc69-91315b0764da/default/388f7284-c407-5ea3-9563-6912852b72b3/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.ninja-turtle.industry',
    name: 'object-capture.showcase.ninja-turtle.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/9a27a4e4-92bc-57e0-ae4e-05316c04fa77/default/7a132229-0c5a-597a-8d62-052e07dc2134/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/9a27a4e4-92bc-57e0-ae4e-05316c04fa77/default/7a132229-0c5a-597a-8d62-052e07dc2134/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.ogre.industry',
    name: 'object-capture.showcase.ogre.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/428d8c42-77bd-5d82-a423-1d3c1007a118/default/ff8f7b61-ae9e-58a4-8129-e78d84fd49fa/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/428d8c42-77bd-5d82-a423-1d3c1007a118/default/ff8f7b61-ae9e-58a4-8129-e78d84fd49fa/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.juventus-peluche.industry',
    name: 'object-capture.showcase.juventus-peluche.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/732c6785-f50b-5bd0-a7ef-1d36494a0ec8/default/9f90eac4-402c-508e-8a7f-06606c5699eb/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/732c6785-f50b-5bd0-a7ef-1d36494a0ec8/default/9f90eac4-402c-508e-8a7f-06606c5699eb/export/preview.jpg'
  },
  {
    industry: 'object-capture.showcase.kids-football-trophy.industry',
    name: 'object-capture.showcase.kids-football-trophy.name',
    src: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/858b42e0-248a-500f-9f63-a824f4b7dbda/default/2f180c40-49f4-5002-8539-3928764b9192/index.html',
    preview: 'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/858b42e0-248a-500f-9f63-a824f4b7dbda/default/2f180c40-49f4-5002-8539-3928764b9192/export/preview.jpg'
  },

]


</script>

<style scoped>
.console {
  background-image: url("~/assets/img/examples/anamorphic-hero.webp");
}

video.fullscreen {
  position: absolute;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h3 {
  @apply text-3xl text-highlight font-bold mt-2
}
.font-smaller {
  font-size: 70%;
  @apply text-standard
  /* @apply text-highlight */
}

.laptop\:bottom-hero {
  bottom: 1.5rem;
}
</style>
